
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1eLpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f414b9754c580ac$export$2e2bcd8739ae039);

var $i1xSm = parcelRequire("i1xSm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $2gCtH = parcelRequire("2gCtH");

var $czfFt = parcelRequire("czfFt");

var $cee7x = parcelRequire("cee7x");

var $koeKL = parcelRequire("koeKL");

var $38bVB = parcelRequire("38bVB");

var $4R6GH = parcelRequire("4R6GH");

var $1daAU = parcelRequire("1daAU");

var $cm5lq = parcelRequire("cm5lq");

var $aBLlP = parcelRequire("aBLlP");
const $9f414b9754c580ac$var$getSkeletonMaxRows = ()=>{
    // Prioritise the pagination FG since it will always max out to the page size
    if ((0, $4R6GH.fg)('jira-issue-view-child-issues-panel-pagination')) return 0, $1daAU.CHILD_ISSUES_PAGE_SIZE;
    // Then use the SSR FG
    if ((0, $4R6GH.fg)('magma-3191-render-chin-skeleton-in-ssr')) return (0, $38bVB.getChildIssuesLimit)();
    return 0, $cee7x.MAX_ROWS;
};
const $9f414b9754c580ac$var$useConfigurableChildIssuesPanelEntryPoint = ({ filterSubtasks: filterSubtasks, hideDone: hideDone, rankFieldJql: rankFieldJql })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            variables: (0, $aBLlP.createConfigurableChildIssuesPanelQueryVariables)({
                cloudId: cloudId,
                jql: (0, $aBLlP.JQLBuilder)({
                    issueKey: issueKey,
                    filterSubtasks: filterSubtasks,
                    hideDone: hideDone ? 'true' : null,
                    sortColumn: rankFieldJql,
                    sortDirection: (0, $czfFt.SORT_ASC)
                }),
                fieldSetIds: [],
                issueKey: issueKey
            })
        }), [
        cloudId,
        filterSubtasks,
        hideDone,
        issueKey,
        rankFieldJql
    ]);
    const hasLoadedEntrypoint = (0, $5uXOq.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $cm5lq.configurableChildIssuesPanelEntryPoint), entryPointParams);
    if (!hasLoadedEntrypoint.current) {
        entryPointActions.load();
        hasLoadedEntrypoint.current = true;
    }
    return {
        entryPointReferenceSubject: entryPointReferenceSubject
    };
};
const $9f414b9754c580ac$var$AsyncConfigurableChildIssuesPanelUsingEntryPoint = ({ columnPickerRef: columnPickerRef, projectId: projectId, parentIssueTypeId: parentIssueTypeId, filterSubtasks: filterSubtasks, rootRelayFragment: rootRelayFragment, totalChildIssueCount: totalChildIssueCount, containerWidth: containerWidth })=>{
    const data = (0, $8Uumt.useFragment)((0, $i1xSm.default), rootRelayFragment?.jira ?? null);
    const rankFieldJql = data?.rankField?.jqlTerm || (0, $1daAU.SORT_OPTION).CREATED;
    const isHideDoneFilterEnabled = Boolean(data?.userPreferences?.isIssueViewHideDoneChildIssuesFilterEnabled);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            columnPickerRef: columnPickerRef,
            filterSubtasks: filterSubtasks,
            projectId: projectId,
            parentIssueTypeId: parentIssueTypeId,
            rankFieldJql: rankFieldJql,
            rootRelayFragment: rootRelayFragment,
            isHideDoneFilterEnabled: isHideDoneFilterEnabled,
            containerWidth: containerWidth
        }), [
        columnPickerRef,
        filterSubtasks,
        projectId,
        parentIssueTypeId,
        rankFieldJql,
        rootRelayFragment,
        isHideDoneFilterEnabled,
        containerWidth
    ]);
    const { entryPointReferenceSubject: entryPointReferenceSubject } = $9f414b9754c580ac$var$useConfigurableChildIssuesPanelEntryPoint({
        filterSubtasks: filterSubtasks,
        rankFieldJql: rankFieldJql,
        hideDone: isHideDoneFilterEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "AsyncConfigurableChildIssuesPanel",
        packageName: "jiraIssueViewCommonViews",
        teamName: "bento",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cee7x.ChildIssuesPanelSkeleton), {
            rows: totalChildIssueCount,
            maxRows: $9f414b9754c580ac$var$getSkeletonMaxRows()
        }),
        runtimeProps: runtimeProps
    });
};
var $9f414b9754c580ac$export$2e2bcd8739ae039 = $9f414b9754c580ac$var$AsyncConfigurableChildIssuesPanelUsingEntryPoint;

});
parcelRegister("i1xSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $274ad3024a4c1648$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d562f1c657a122a87b7df4a14d511876>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $274ad3024a4c1648$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "async_issueViewCommonViews_AsyncConfigurableChildIssuesPanelUsingEntryPoint",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isIssueViewHideDoneChildIssuesFilterEnabled"
                    }
                ]
            },
            {
                "args": v0 /*: any*/ ,
                "concreteType": "JiraJqlFieldWithAliases",
                "kind": "LinkedField",
                "name": "rankField",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$274ad3024a4c1648$var$node.hash = "4fa20f3c6f4db2528a3ff03b38d3501a";
var $274ad3024a4c1648$export$2e2bcd8739ae039 = $274ad3024a4c1648$var$node;

});

parcelRegister("czfFt", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $7f8ee02f08da8eac$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SORT_ASC", () => $7f8ee02f08da8eac$export$88956207daf9a17e);
$parcel$export(module.exports, "SORT_DESC", () => $7f8ee02f08da8eac$export$bc14f97913aaf2a);
$parcel$export(module.exports, "SORT_NONE", () => $7f8ee02f08da8eac$export$9c424bf3e8ffe64e);
$parcel$export(module.exports, "MODIFY_COLUMNS", () => $7f8ee02f08da8eac$export$1f921c78ce6d243c);
$parcel$export(module.exports, "REORDER_COLUMNS", () => $7f8ee02f08da8eac$export$83371d6c41a974aa);
$parcel$export(module.exports, "RESTORE_COLUMNS", () => $7f8ee02f08da8eac$export$3bfe53b79fc4f6ed);
$parcel$export(module.exports, "MOVE_COLUMN_FIRST", () => $7f8ee02f08da8eac$export$957d455bb65919d8);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT", () => $7f8ee02f08da8eac$export$2082861c970802b0);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT", () => $7f8ee02f08da8eac$export$21847d308b0769ad);
$parcel$export(module.exports, "MOVE_COLUMN_LAST", () => $7f8ee02f08da8eac$export$c32913bc261af82d);
$parcel$export(module.exports, "BORDER_WIDTH", () => $7f8ee02f08da8eac$export$e2bd4c1faded7921);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $7f8ee02f08da8eac$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "ROW_HEIGHT", () => $7f8ee02f08da8eac$export$88e6c5bab2ff80e8);
$parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", () => $7f8ee02f08da8eac$export$de4c02b525d877fa);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $7f8ee02f08da8eac$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $7f8ee02f08da8eac$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_INTERNAL_COLUMN", () => $7f8ee02f08da8eac$export$b4e9105b7f5f1b0f);
$parcel$export(module.exports, "ACTION_COLUMNS", () => $7f8ee02f08da8eac$export$3dbdc5c16825be4d);
$parcel$export(module.exports, "EXPAND_BUTTON_WIDTH", () => $7f8ee02f08da8eac$export$a1c171a82c45d53f);
$parcel$export(module.exports, "CREATE_CHILD_BUTTON_WIDTH", () => $7f8ee02f08da8eac$export$43ff8c492b8a2e1b);
$parcel$export(module.exports, "EXPAND_CELL_PADDING", () => $7f8ee02f08da8eac$export$9c5dd6078b37aac2);
$parcel$export(module.exports, "DEPTH_WIDTH", () => $7f8ee02f08da8eac$export$a8273d7d48e89fce);
$parcel$export(module.exports, "MAX_COLUMNS", () => $7f8ee02f08da8eac$export$7ec4af037f372df4);
$parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", () => $7f8ee02f08da8eac$export$d2372dfbd4e91a11);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $7f8ee02f08da8eac$export$1adf7afff96bbf16);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH_COMPACT", () => $7f8ee02f08da8eac$export$10016003aa27fa67);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$5575b9e0ed3ff59f);
$parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$7c3f559e2ca95fa);
$parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$e1a42c2fefb5af25);
$parcel$export(module.exports, "SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$54fb99171fb48426);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", () => $7f8ee02f08da8eac$export$bfe09a9186b98f8f);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", () => $7f8ee02f08da8eac$export$f2540f34b796306d);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", () => $7f8ee02f08da8eac$export$954afb0fcf5a326);
$parcel$export(module.exports, "COLUMN_OPERATION_REORDER", () => $7f8ee02f08da8eac$export$93758649595b2d58);
$parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", () => $7f8ee02f08da8eac$export$cad8c6a0b6e78898);
$parcel$export(module.exports, "INSERT_COLUMN_BUTTON_Y_OFFSET", () => $7f8ee02f08da8eac$export$5252387dc65db584);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", () => $7f8ee02f08da8eac$export$754b76ac8fa63350);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", () => $7f8ee02f08da8eac$export$fa5c7dad7ee16383);
$parcel$export(module.exports, "ROW_OPERATION_REORDER", () => $7f8ee02f08da8eac$export$4e8abe16cd1126dd);
$parcel$export(module.exports, "DENSITY_COMPACT", () => $7f8ee02f08da8eac$export$6c0a5a77457ca62);
$parcel$export(module.exports, "DENSITY_FULL", () => $7f8ee02f08da8eac$export$119d8ab9a5bc4b2);
$parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", () => $7f8ee02f08da8eac$export$9ef77944c441ad07);
$parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", () => $7f8ee02f08da8eac$export$c1f680390b97c9e1);
$parcel$export(module.exports, "CHILD_ITEMS_EXPERIENCE", () => $7f8ee02f08da8eac$export$e03155205bf92428);
$parcel$export(module.exports, "CHILD_ITEMS_LOAD_MORE_EXPERIENCE", () => $7f8ee02f08da8eac$export$311c64c0d94dcdf3);
$parcel$export(module.exports, "GROUPED_ITEMS_EXPERIENCE", () => $7f8ee02f08da8eac$export$f5d215df3c6473e9);
$parcel$export(module.exports, "GROUPED_LOAD_MORE_EXPERIENCE", () => $7f8ee02f08da8eac$export$b4fd503bf7cccacd);
$parcel$export(module.exports, "INLINE_ISSUE_CREATE_EXPERIENCE", () => $7f8ee02f08da8eac$export$70f80a241e016093);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $7f8ee02f08da8eac$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "MAKE_CHILD", () => $7f8ee02f08da8eac$export$5eb61e3ff74a4f58);
$parcel$export(module.exports, "REORDER_ABOVE", () => $7f8ee02f08da8eac$export$9213b5774112217f);
$parcel$export(module.exports, "REORDER_BELOW", () => $7f8ee02f08da8eac$export$118b06a03e2c672f);
$parcel$export(module.exports, "INSTRUCTION_BLOCKED", () => $7f8ee02f08da8eac$export$71b8539e20744dab);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $7f8ee02f08da8eac$export$5b388ccfa29be01);
$parcel$export(module.exports, "COLUMN_PICKER_CONFIGURATION_CONTAINER", () => $7f8ee02f08da8eac$export$f6d7582f33b86010);
$parcel$export(module.exports, "COLUMN_PICKER_ADD_COLUMN_CONTAINER", () => $7f8ee02f08da8eac$export$f92486d03c064eac);
$parcel$export(module.exports, "MAX_LINE_WRAP_OLD", () => $7f8ee02f08da8eac$export$139bffb2a576e8c0);
$parcel$export(module.exports, "MAX_LINE_WRAP_NEW", () => $7f8ee02f08da8eac$export$3b696b0ac06c2cc4);
$parcel$export(module.exports, "HIGHLIGHT_LINGER_DURATION_MS", () => $7f8ee02f08da8eac$export$6ba5aaedfd1b5319);
$parcel$export(module.exports, "SORT_A_TO_Z", () => $7f8ee02f08da8eac$export$1bc2edb2aa5e8282);
$parcel$export(module.exports, "SORT_Z_TO_A", () => $7f8ee02f08da8eac$export$c7b524b6c48f8273);
$parcel$export(module.exports, "SORT_LOWEST_TO_HIGHEST", () => $7f8ee02f08da8eac$export$9c60c93d5e95e80f);
$parcel$export(module.exports, "SORT_HIGHEST_TO_LOWEST", () => $7f8ee02f08da8eac$export$476f4bdd6eba4fb2);
$parcel$export(module.exports, "SORT_OLDEST_TO_NEWEST", () => $7f8ee02f08da8eac$export$fbcac9f513cf13f4);
$parcel$export(module.exports, "SORT_NEWEST_TO_OLDEST", () => $7f8ee02f08da8eac$export$d3c0241ce8ae9a73);

var $65VLO = parcelRequire("65VLO");
const $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
const $7f8ee02f08da8eac$export$d57b6b390e78d90f = 'empanada';
const $7f8ee02f08da8eac$export$88956207daf9a17e = 'ASC';
const $7f8ee02f08da8eac$export$bc14f97913aaf2a = 'DESC';
const $7f8ee02f08da8eac$export$9c424bf3e8ffe64e = 'NONE';
const $7f8ee02f08da8eac$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
const $7f8ee02f08da8eac$export$83371d6c41a974aa = 'REORDER_COLUMNS';
const $7f8ee02f08da8eac$export$3bfe53b79fc4f6ed = 'RESTORE_COLUMNS';
const $7f8ee02f08da8eac$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
const $7f8ee02f08da8eac$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
const $7f8ee02f08da8eac$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
const $7f8ee02f08da8eac$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
const $7f8ee02f08da8eac$export$e2bd4c1faded7921 = '1px';
const $7f8ee02f08da8eac$export$cdb7fd9d999c7168 = 40;
const $7f8ee02f08da8eac$export$88e6c5bab2ff80e8 = 40;
const $7f8ee02f08da8eac$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $7f8ee02f08da8eac$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $7f8ee02f08da8eac$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $7f8ee02f08da8eac$export$b4e9105b7f5f1b0f = '__issuetable_internal';
const $7f8ee02f08da8eac$export$3dbdc5c16825be4d = [
    $7f8ee02f08da8eac$export$c3266da279aa6b84,
    $7f8ee02f08da8eac$export$de4c02b525d877fa,
    $7f8ee02f08da8eac$export$66b2a4a5f67468ac,
    (0, $65VLO.COLUMN_ID_MERGED_COLUMN)
];
const $7f8ee02f08da8eac$export$a1c171a82c45d53f = 24;
const $7f8ee02f08da8eac$export$43ff8c492b8a2e1b = 24;
const $7f8ee02f08da8eac$export$9c5dd6078b37aac2 = 16;
const $7f8ee02f08da8eac$export$a8273d7d48e89fce = 24;
const $7f8ee02f08da8eac$export$7ec4af037f372df4 = 500;
const $7f8ee02f08da8eac$export$d2372dfbd4e91a11 = 50;
const $7f8ee02f08da8eac$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $7f8ee02f08da8eac$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $7f8ee02f08da8eac$export$c1d348661674e922 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $7f8ee02f08da8eac$export$67082d449d5ec91 = 'com.atlassian.servicedesk:sd-request-feedback';
const $7f8ee02f08da8eac$export$145a4a20f394acf9 = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $7f8ee02f08da8eac$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $7f8ee02f08da8eac$export$10016003aa27fa67 = 40; // 2 x 8px cell padding + 24px icon size
const $7f8ee02f08da8eac$export$5575b9e0ed3ff59f = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
const $7f8ee02f08da8eac$export$7c3f559e2ca95fa = 170;
const $7f8ee02f08da8eac$export$e1a42c2fefb5af25 = 999;
const $7f8ee02f08da8eac$export$54fb99171fb48426 = 80;
const $7f8ee02f08da8eac$export$a194aa0e243a27f9 = 156;
const $7f8ee02f08da8eac$export$87a3548b97ce2540 = 136;
const $7f8ee02f08da8eac$export$d182a35496b19fb4 = 112;
const $7f8ee02f08da8eac$export$4fd6711c21931f5b = 116;
const $7f8ee02f08da8eac$export$9b72110b9a7c0a39 = 102;
const $7f8ee02f08da8eac$export$54c15048528650a8 = 84;
const $7f8ee02f08da8eac$export$7ed05c26fe24a805 = 200;
const $7f8ee02f08da8eac$export$bfe09a9186b98f8f = 400;
const $7f8ee02f08da8eac$export$f2540f34b796306d = 300;
const $7f8ee02f08da8eac$export$954afb0fcf5a326 = 450;
const $7f8ee02f08da8eac$export$93758649595b2d58 = 'reorder';
const $7f8ee02f08da8eac$export$cad8c6a0b6e78898 = 'resize';
const $7f8ee02f08da8eac$export$5252387dc65db584 = -16;
const $7f8ee02f08da8eac$export$754b76ac8fa63350 = 'FULL_HEIGHT';
const $7f8ee02f08da8eac$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
const $7f8ee02f08da8eac$export$4e8abe16cd1126dd = 'rowReorder';
const $7f8ee02f08da8eac$export$6c0a5a77457ca62 = 'COMPACT';
const $7f8ee02f08da8eac$export$119d8ab9a5bc4b2 = 'FULL';
const $7f8ee02f08da8eac$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
const $7f8ee02f08da8eac$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';
const $7f8ee02f08da8eac$export$e03155205bf92428 = 'loadChildItems';
const $7f8ee02f08da8eac$export$311c64c0d94dcdf3 = 'loadMoreChildItems';
const $7f8ee02f08da8eac$export$f5d215df3c6473e9 = 'loadGroupChildren';
const $7f8ee02f08da8eac$export$b4fd503bf7cccacd = 'loadMoreGroupedItems';
const $7f8ee02f08da8eac$export$70f80a241e016093 = 'createIssue';
const $7f8ee02f08da8eac$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $7f8ee02f08da8eac$export$5eb61e3ff74a4f58 = 'make-child';
const $7f8ee02f08da8eac$export$9213b5774112217f = 'reorder-above';
const $7f8ee02f08da8eac$export$118b06a03e2c672f = 'reorder-below';
const $7f8ee02f08da8eac$export$71b8539e20744dab = 'instruction-blocked';
const $7f8ee02f08da8eac$export$5b388ccfa29be01 = -1;
const $7f8ee02f08da8eac$export$f6d7582f33b86010 = 'COLUMN_PICKER_CONFIGURATION_CONTAINER';
const $7f8ee02f08da8eac$export$f92486d03c064eac = 'COLUMN_PICKER_ADD_COLUMN_CONTAINER';
const $7f8ee02f08da8eac$export$139bffb2a576e8c0 = 2;
const $7f8ee02f08da8eac$export$3b696b0ac06c2cc4 = 1;
const $7f8ee02f08da8eac$export$6ba5aaedfd1b5319 = 2000;
const $7f8ee02f08da8eac$export$1bc2edb2aa5e8282 = 'a_to_z';
const $7f8ee02f08da8eac$export$c7b524b6c48f8273 = 'z_to_a';
const $7f8ee02f08da8eac$export$9c60c93d5e95e80f = 'lowest_to_highest';
const $7f8ee02f08da8eac$export$476f4bdd6eba4fb2 = 'highest_to_lowest';
const $7f8ee02f08da8eac$export$fbcac9f513cf13f4 = 'oldest_to_newest';
const $7f8ee02f08da8eac$export$d3c0241ce8ae9a73 = 'newest_to_oldest';

});
parcelRegister("65VLO", function(module, exports) {

$parcel$export(module.exports, "KNOWN_COLUMN_TYPES", () => $1fec13ea3747c865$export$bbc2e8c301f97f97);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $1fec13ea3747c865$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $1fec13ea3747c865$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_MERGED_COLUMN", () => $1fec13ea3747c865$export$3237751348c4f1b);
$parcel$export(module.exports, "MERGED_COLUMN_IDS", () => $1fec13ea3747c865$export$70f30e260ec270f2);
$parcel$export(module.exports, "MERGED_COLUMN_DEFAULT_WIDTH", () => $1fec13ea3747c865$export$6aa1d347deb86ef3);
const $1fec13ea3747c865$export$bbc2e8c301f97f97 = {
    ASSIGNEE: 'assignee',
    CHECKBOX: '__issuetable_internal_checkbox',
    CHECKBOX_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    DESCRIPTION: 'description',
    ENVIRONMENT: 'environment',
    EXPAND_BUTTON: '__issuetable_internal_expand_button',
    ISSUE_KEY: 'issuekey',
    ISSUE_OPERATIONS: '__issuetable_internal_meatball',
    STATUS: 'status',
    SUMMARY: 'summary',
    ISSUE_TYPE: 'issuetype',
    RESOLUTION: 'resolution',
    PARENT: 'parent',
    LABELS: 'labels',
    COMPONENTS: 'components',
    FIX_VERSIONS: 'fixVersions',
    STATUS_CATEGORY: 'statusCategory',
    PROJECT: 'project',
    READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
    SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
    TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
    CREATED: 'created',
    RESOLUTION_DATE: 'resolutiondate',
    TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
    UPDATED: 'updated',
    DUE_DATE: 'duedate',
    REPORTER: 'reporter',
    CREATOR: 'creator',
    PRIORITY: 'priority',
    AFFECTS_VERSIONS: 'versions',
    REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
    NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
    STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points',
    USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
    CUSTOM_LABELS: 'com.atlassian.jira.plugin.system.customfieldtypes:labels',
    DATE_TIME: 'com.atlassian.jira.plugin.system.customfieldtypes:datetime',
    URL: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
    SINGLE_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
    MULTI_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    MULTI_USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker',
    MERGED_COLUMN: '__issuetable_internal_merged_column',
    TEAM: 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team',
    ORIGINAL_ESTIMATE: 'timeoriginalestimate',
    GOALS: 'com.atlassian.jira.plugin.system.customfieldtypes:goals',
    CASCADING_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
    CONFLUENCE_PAGES: 'confluenceRemoteIssueLinks',
    PEOPLE: 'com.atlassian.jira.plugin.system.customfieldtypes:people',
    DATE_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker'
};
const $1fec13ea3747c865$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $1fec13ea3747c865$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $1fec13ea3747c865$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $1fec13ea3747c865$export$3237751348c4f1b = '__issuetable_internal_merged_column';
const $1fec13ea3747c865$export$72f66561203b705c = [
    $1fec13ea3747c865$export$bbc2e8c301f97f97.ISSUE_TYPE,
    $1fec13ea3747c865$export$bbc2e8c301f97f97.ISSUE_KEY,
    $1fec13ea3747c865$export$bbc2e8c301f97f97.SUMMARY
];
const $1fec13ea3747c865$export$70f30e260ec270f2 = [
    'issuetype',
    'issuekey',
    'summary'
];
const $1fec13ea3747c865$export$6aa1d347deb86ef3 = 64; // 24 * 2 (two icons) + 8*2 (horizontal padding)

});


parcelRegister("cm5lq", function(module, exports) {

$parcel$export(module.exports, "configurableChildIssuesPanelEntryPoint", () => $c172567089cdc56c$export$e5791bfbf3e1a041);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $2ortv = parcelRequire("2ortv");

const $c172567089cdc56c$export$e5791bfbf3e1a041 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("8mLHi")).then((module)=>module.ConfigurableChildIssuesPanelWithEntryPoint), {
        moduleId: "466cfd1a",
        priority: "interaction"
    }),
    getPreloadProps: ({ variables: variables })=>({
            queries: {
                childIssuesData: {
                    options: {
                        fetchKey: 'issue',
                        fetchPolicy: 'store-or-network',
                        name: 'issueViewCommon'
                    },
                    parameters: $2ortv.default,
                    variables: variables
                }
            }
        })
});

});
parcelRegister("2ortv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b11aca1b1ae9dfc5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1dc9a9243ee94252163d411418828db>>
 * @relayHash 929be2f1d49d2f7d0b5b5199f9e58731
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d7d60ac8cfc46a39bd4c60c4fd9a0b8e436c009dd9b314211eca03591a40c077

var $fjldt = parcelRequire("fjldt");

var $gY76A = parcelRequire("gY76A");

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $iMyvd = parcelRequire("iMyvd");

var $2pNN7 = parcelRequire("2pNN7");

var $5Bxi4 = parcelRequire("5Bxi4");

var $k3PJZ = parcelRequire("k3PJZ");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $b11aca1b1ae9dfc5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "type"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v16 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v17 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v18 = {
        "kind": "ClientExtension",
        "selections": [
            v17 /*: any*/ 
        ]
    }, v19 = [
        v11 /*: any*/ 
    ], v20 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "key"
    }, v22 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v23 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v24 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        v9 /*: any*/ ,
        v22 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v23 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v27 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v28 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v29 = {
        "kind": "InlineFragment",
        "selections": [
            v15 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v28 /*: any*/ ,
                    v11 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "ids",
                "value": [
                    "status"
                ]
            }
        ],
        "concreteType": "JiraIssueFieldConnection",
        "kind": "LinkedField",
        "name": "fieldsById",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v10 /*: any*/ ,
                            v29 /*: any*/ ,
                            v11 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldsById(ids:[\"status\"])"
    }, v31 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v32 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v11 /*: any*/ 
                ]
            },
            v11 /*: any*/ 
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "name"
    }, v34 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v35 = {
        "kind": "ClientExtension",
        "selections": [
            v17 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
            }
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "value"
    }, v37 = [
        v36 /*: any*/ ,
        v11 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v38 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v39 = {
        "kind": "ClientExtension",
        "selections": [
            v38 /*: any*/ 
        ]
    }, v40 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v41 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v42 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v43 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v44 = {
        "kind": "ScalarField",
        "name": "text"
    }, v45 = {
        "kind": "InlineFragment",
        "selections": [
            v44 /*: any*/ ,
            v33 /*: any*/ ,
            v39 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v46 = [
        v16 /*: any*/ 
    ], v47 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v11 /*: any*/ 
        ]
    }, v48 = [
        v47 /*: any*/ 
    ], v49 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v50 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v51 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v52 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v53 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v54 = [
        v33 /*: any*/ ,
        v11 /*: any*/ 
    ], v55 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v56 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v44 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v57 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v47 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v58 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v59 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v58 /*: any*/ ,
                    v33 /*: any*/ ,
                    v11 /*: any*/ 
                ]
            },
            v11 /*: any*/ 
        ]
    }, v60 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v61 = {
        "kind": "ScalarField",
        "name": "number"
    }, v62 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v63 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 500
            }
        ],
        "concreteType": "JiraIssueFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ ,
                            v12 /*: any*/ ,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v10 /*: any*/ ,
                                                    v15 /*: any*/ ,
                                                    v13 /*: any*/ ,
                                                    {
                                                        "kind": "TypeDiscriminator",
                                                        "abstractKey": "__isJiraIssueField"
                                                    },
                                                    v11 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraAffectedServiceConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedAffectedServicesConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraAffectedServiceEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraAffectedService",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "serviceId"
                                                                                    },
                                                                                    v33 /*: any*/ ,
                                                                                    v11 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraAffectedServicesField"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraCascadingOption",
                                                                        "kind": "LinkedField",
                                                                        "name": "cascadingOption",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraOption",
                                                                                "kind": "LinkedField",
                                                                                "name": "parentOptionValue",
                                                                                "plural": false,
                                                                                "selections": v37 /*: any*/ 
                                                                            },
                                                                            {
                                                                                "concreteType": "JiraOption",
                                                                                "kind": "LinkedField",
                                                                                "name": "childOptionValue",
                                                                                "plural": false,
                                                                                "selections": v37 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    },
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraCascadingSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "args": v40 /*: any*/ ,
                                                                        "concreteType": "JiraComponentConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedComponentsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponentEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraComponent",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v41 /*: any*/ ,
                                                                                            v42 /*: any*/ ,
                                                                                            v11 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "selectedComponentsConnection(first:1000)"
                                                                    },
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraComponentsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v43 /*: any*/ ,
                                                                    v33 /*: any*/ ,
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraDateTimePickerField"
                                                            },
                                                            v45 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraCommentSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "commentSummary",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "canAddComment"
                                                                            },
                                                                            v16 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraCommentSummaryField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "uri"
                                                                    },
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraUrlField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraOptionConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldOptions",
                                                                        "plural": false,
                                                                        "selections": v46 /*: any*/ 
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraOption",
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldOption",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v36 /*: any*/ ,
                                                                            {
                                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": v48 /*: any*/ 
                                                                            },
                                                                            {
                                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": v48 /*: any*/ 
                                                                            },
                                                                            v11 /*: any*/ ,
                                                                            v49 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraOptionConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedOptions",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraOptionEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraOption",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v11 /*: any*/ ,
                                                                                            v36 /*: any*/ ,
                                                                                            v49 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraMultipleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraOptionConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedOptions",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraOptionEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v50 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraCheckboxesField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraUserConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedUsersConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraUserEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v10 /*: any*/ ,
                                                                                            v51 /*: any*/ ,
                                                                                            v33 /*: any*/ ,
                                                                                            v52 /*: any*/ ,
                                                                                            v11 /*: any*/ ,
                                                                                            v53 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "email"
                                                                                                    }
                                                                                                ],
                                                                                                "type": "AtlassianAccountUser"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraMultipleSelectUserPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraTeamView",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedTeam",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "jiraSuppliedId"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "jiraSuppliedName"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraTeamViewField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "issue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraTimeTrackingField",
                                                                                "kind": "LinkedField",
                                                                                "name": "timeTrackingField",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v11 /*: any*/ ,
                                                                                    {
                                                                                        "concreteType": "JiraEstimate",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "originalEstimate",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "timeInSeconds"
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraTimeTrackingSettings",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "timeTrackingSettings",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "workingHoursPerDay"
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "workingDaysPerWeek"
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "defaultFormat"
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "defaultUnit"
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    v15 /*: any*/ ,
                                                                                    v33 /*: any*/ ,
                                                                                    v13 /*: any*/ ,
                                                                                    v39 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            v11 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraOriginalTimeEstimateField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraOption",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedOption",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "alias": "label",
                                                                                "kind": "ScalarField",
                                                                                "name": "value"
                                                                            },
                                                                            v11 /*: any*/ ,
                                                                            v41 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraRadioSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "args": v40 /*: any*/ ,
                                                                        "concreteType": "JiraVersionConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedVersionsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraVersionEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraVersion",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v11 /*: any*/ ,
                                                                                            v33 /*: any*/ ,
                                                                                            v41 /*: any*/ ,
                                                                                            v42 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "versionId"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "selectedVersionsConnection(first:1000)"
                                                                    },
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraMultipleVersionPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "issue",
                                                                        "plural": false,
                                                                        "selections": v19 /*: any*/ 
                                                                    },
                                                                    {
                                                                        "args": v40 /*: any*/ ,
                                                                        "concreteType": "JiraGoalConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedGoals",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraGoalEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraGoal",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v11 /*: any*/ ,
                                                                                            v21 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v18 /*: any*/ 
                                                                        ],
                                                                        "storageKey": "selectedGoals(first:1000)"
                                                                    },
                                                                    {
                                                                        "kind": "ClientExtension",
                                                                        "selections": [
                                                                            v17 /*: any*/ ,
                                                                            v38 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraGoalsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "args": v40 /*: any*/ ,
                                                                        "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "confluenceRemoteIssueLinks",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v11 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "href"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v16 /*: any*/ 
                                                                        ],
                                                                        "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                    },
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraConfluenceRemoteIssueLinksField"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraCmdbObjectConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedCmdbObjectsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraCmdbObjectEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraCmdbObject",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "objectId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "label"
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraCmdbAvatar",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "avatar",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "mediaClientConfig",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "clientId"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "fileId"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "mediaBaseUrl"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "mediaJwtToken"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "url48"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "QueryError",
                                                                        "kind": "LinkedField",
                                                                        "name": "errors",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "message"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraCMDBField"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "alias": "componentsOld",
                                                                        "concreteType": "JiraComponentConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedComponentsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponentEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraComponent",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": v54 /*: any*/ 
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraComponentsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v44 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "date"
                                                            },
                                                            v33 /*: any*/ ,
                                                            v55 /*: any*/ ,
                                                            v39 /*: any*/ 
                                                        ],
                                                        "type": "JiraDatePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v43 /*: any*/ 
                                                        ],
                                                        "type": "JiraDateTimePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraEpic",
                                                                "kind": "LinkedField",
                                                                "name": "epic",
                                                                "plural": false,
                                                                "selections": [
                                                                    v21 /*: any*/ ,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "summary"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "color"
                                                                    },
                                                                    v11 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraEpicLinkField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "renderedFieldHtml"
                                                            }
                                                        ],
                                                        "type": "JiraFallbackField"
                                                    },
                                                    v45 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v11 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusCategoryField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusId"
                                                                    },
                                                                    v28 /*: any*/ ,
                                                                    v11 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v40 /*: any*/ ,
                                                                "concreteType": "JiraLabelConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedLabelsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraLabelEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraLabel",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v33 /*: any*/ ,
                                                                                    v47 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v16 /*: any*/ 
                                                                ],
                                                                "storageKey": "selectedLabelsConnection(first:1000)"
                                                            },
                                                            v33 /*: any*/ ,
                                                            v39 /*: any*/ 
                                                        ],
                                                        "type": "JiraLabelsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "small"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v33 /*: any*/ ,
                                                                    v11 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssue",
                                                                "kind": "LinkedField",
                                                                "name": "parentIssue",
                                                                "plural": false,
                                                                "selections": [
                                                                    v21 /*: any*/ ,
                                                                    v56 /*: any*/ ,
                                                                    v11 /*: any*/ 
                                                                ]
                                                            },
                                                            {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "parentIssue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v21 /*: any*/ ,
                                                                            v57 /*: any*/ ,
                                                                            v59 /*: any*/ ,
                                                                            v56 /*: any*/ ,
                                                                            v11 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "parentIssue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v21 /*: any*/ ,
                                                                            v57 /*: any*/ ,
                                                                            v59 /*: any*/ ,
                                                                            v56 /*: any*/ ,
                                                                            v11 /*: any*/ ,
                                                                            v25 /*: any*/ ,
                                                                            v60 /*: any*/ ,
                                                                            {
                                                                                "args": [
                                                                                    {
                                                                                        "kind": "Literal",
                                                                                        "name": "ids",
                                                                                        "value": [
                                                                                            "summary",
                                                                                            "issuetype",
                                                                                            "status"
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "fieldsById",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v10 /*: any*/ ,
                                                                                                    v11 /*: any*/ ,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v15 /*: any*/ ,
                                                                                                            v44 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "JiraSingleLineTextField"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v15 /*: any*/ ,
                                                                                                            {
                                                                                                                "concreteType": "JiraIssueType",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "issueType",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "issueTypeId"
                                                                                                                    },
                                                                                                                    v33 /*: any*/ ,
                                                                                                                    v58 /*: any*/ ,
                                                                                                                    v31 /*: any*/ ,
                                                                                                                    v11 /*: any*/ 
                                                                                                                ]
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraIssueTypeField"
                                                                                                    },
                                                                                                    v29 /*: any*/ 
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v33 /*: any*/ ,
                                                                    v39 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraParentIssueField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraPriority",
                                                                "kind": "LinkedField",
                                                                "name": "priority",
                                                                "plural": false,
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "iconUrl"
                                                                    },
                                                                    v11 /*: any*/ 
                                                                ]
                                                            },
                                                            v33 /*: any*/ ,
                                                            v39 /*: any*/ 
                                                        ],
                                                        "type": "JiraPriorityField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    v21 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "large"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v11 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraProjectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraResolution",
                                                                "kind": "LinkedField",
                                                                "name": "resolution",
                                                                "plural": false,
                                                                "selections": v54 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraResolutionField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSprintConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedSprintsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprintEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSprint",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v11 /*: any*/ ,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "sprintId"
                                                                                    },
                                                                                    v33 /*: any*/ ,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "state"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "endDate"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            v33 /*: any*/ ,
                                                            v39 /*: any*/ 
                                                        ],
                                                        "type": "JiraSprintField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v10 /*: any*/ ,
                                                                    v51 /*: any*/ ,
                                                                    v52 /*: any*/ ,
                                                                    v33 /*: any*/ ,
                                                                    v11 /*: any*/ ,
                                                                    v53 /*: any*/ 
                                                                ]
                                                            },
                                                            v33 /*: any*/ ,
                                                            v55 /*: any*/ ,
                                                            v39 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v33 /*: any*/ ,
                                                            {
                                                                "args": v40 /*: any*/ ,
                                                                "concreteType": "JiraVersionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedVersionsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraVersion",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v54 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedVersionsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraMultipleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraRichText",
                                                                "kind": "LinkedField",
                                                                "name": "richText",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraADF",
                                                                        "kind": "LinkedField",
                                                                        "name": "adfValue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraAdfToConvertedPlainText",
                                                                                "kind": "LinkedField",
                                                                                "name": "convertedPlainText",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "plainText"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraRichTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraServiceManagementRequestType",
                                                                "kind": "LinkedField",
                                                                "name": "requestType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    v58 /*: any*/ ,
                                                                    v11 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraServiceManagementRequestTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "first",
                                                                        "value": 1
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueLinkConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issueLinkConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    v16 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraIssueLinkEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueLink",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssue",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "issue",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v60 /*: any*/ ,
                                                                                            v21 /*: any*/ ,
                                                                                            {
                                                                                                "args": [
                                                                                                    {
                                                                                                        "kind": "Literal",
                                                                                                        "name": "ids",
                                                                                                        "value": [
                                                                                                            "statusCategory"
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "fieldsById",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "edges",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "node",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v10 /*: any*/ ,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v28 /*: any*/ 
                                                                                                                        ],
                                                                                                                        "type": "JiraStatusCategoryField"
                                                                                                                    },
                                                                                                                    v11 /*: any*/ 
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                            },
                                                                                            v11 /*: any*/ 
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "relationName"
                                                                                    },
                                                                                    v11 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "issueLinkConnection(first:1)"
                                                            }
                                                        ],
                                                        "type": "JiraIssueLinkField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "isStoryPointField"
                                                            },
                                                            v61 /*: any*/ ,
                                                            v33 /*: any*/ ,
                                                            {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": false,
                                                                "selections": [
                                                                    v61 /*: any*/ ,
                                                                    v62 /*: any*/ 
                                                                ]
                                                            },
                                                            {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    v61 /*: any*/ ,
                                                                    v33 /*: any*/ ,
                                                                    v62 /*: any*/ ,
                                                                    v39 /*: any*/ 
                                                                ]
                                                            },
                                                            v39 /*: any*/ 
                                                        ],
                                                        "type": "JiraNumberField"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraGroupConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedGroupsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraGroupEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraGroup",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v11 /*: any*/ ,
                                                                                            v33 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "groupId"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraMultipleGroupPickerField"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraFlag",
                                                                        "kind": "LinkedField",
                                                                        "name": "flag",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "isFlagged"
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraFlagField"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraWatch",
                                                                        "kind": "LinkedField",
                                                                        "name": "watch",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "count"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "isWatching"
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraWatchesField"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOptionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOptions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOptionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v50 /*: any*/ ,
                                                                            v18 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraCheckboxesField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "fieldOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    v49 /*: any*/ ,
                                                                    v11 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    },
                                                    v18 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": v46 /*: any*/ 
                                    }
                                ]
                            },
                            v18 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldSets(first:500)"
    }, v64 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v65 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v66 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v67 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v68 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "firstIssuePosition"
            },
            {
                "kind": "ScalarField",
                "name": "lastIssuePosition"
            }
        ]
    }, v69 = [
        v64 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v70 = {
        "args": [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ],
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": v69 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v69 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": v69 /*: any*/ 
            }
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v71 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v10 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_main_ConfigurableChildIssuesPanelWithEntryPointQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v8 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_main_ConfigurableChildIssuesPanelWithEntryPointQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "issueKey",
                                    "variableName": "issueKey"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "fieldSetViewQueryByProject",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasDefaultFieldSets"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "fieldSetSelectedState": "SELECTED"
                                                    }
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "amountOfColumns"
                                                }
                                            ],
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                v13 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "jqlTerm"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isSortable"
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetPreferences",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "width"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsMetadata",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "canBeConfigured"
                                                                                                },
                                                                                                v15 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isPlaceHolderField"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldType",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v16 /*: any*/ ,
                                                v18 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraFieldSetView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v19 /*: any*/ ,
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "key",
                                            "variableName": "issueKey"
                                        }
                                    ],
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectField",
                                            "kind": "LinkedField",
                                            "name": "projectField",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": "editIssues",
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "type",
                                                                            "value": "EDIT_ISSUES"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraProjectAction",
                                                                    "kind": "LinkedField",
                                                                    "name": "action",
                                                                    "plural": false,
                                                                    "selections": v20 /*: any*/ ,
                                                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": "createIssues",
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "type",
                                                                            "value": "CREATE_ISSUES"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraProjectAction",
                                                                    "kind": "LinkedField",
                                                                    "name": "action",
                                                                    "plural": false,
                                                                    "selections": v20 /*: any*/ ,
                                                                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        v21 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v24 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        v32 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v34 /*: any*/ ,
                                                        v35 /*: any*/ 
                                                    ]
                                                },
                                                v10 /*: any*/ ,
                                                v63 /*: any*/ ,
                                                v64 /*: any*/ ,
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        v65 /*: any*/ ,
                                        v66 /*: any*/ ,
                                        v67 /*: any*/ ,
                                        v68 /*: any*/ ,
                                        v70 /*: any*/ ,
                                        v71 /*: any*/ ,
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v24 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "ChildIssuesPanelIssueSearchPagination__issueSearch",
                                    "kind": "LinkedHandle",
                                    "name": "issueSearch"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        v9 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearchStable",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        v32 /*: any*/ ,
                                                        v34 /*: any*/ ,
                                                        v35 /*: any*/ 
                                                    ]
                                                },
                                                v10 /*: any*/ ,
                                                v63 /*: any*/ ,
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        v65 /*: any*/ ,
                                        v66 /*: any*/ ,
                                        v67 /*: any*/ ,
                                        v68 /*: any*/ ,
                                        v70 /*: any*/ ,
                                        v71 /*: any*/ ,
                                        v18 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d7d60ac8cfc46a39bd4c60c4fd9a0b8e436c009dd9b314211eca03591a40c077",
            "metadata": {},
            "name": "ui_main_ConfigurableChildIssuesPanelWithEntryPointQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider": (0, $2pNN7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $iMyvd.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider": (0, $5Bxi4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $gY76A.default)
            }
        }
    };
}();
$b11aca1b1ae9dfc5$var$node.hash = "f6bbaa8034a53f8946640763fe8e67ad";
var $b11aca1b1ae9dfc5$export$2e2bcd8739ae039 = $b11aca1b1ae9dfc5$var$node;

});
parcelRegister("fjldt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dad5d6a9d81ef63f$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $dad5d6a9d81ef63f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false);
    }
};

});

parcelRegister("gY76A", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b308b8f84a32bbf$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5b308b8f84a32bbf$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira_inline_field_config_gate');
    }
};

});

parcelRegister("5ykrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a88313492930423$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5a88313492930423$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('render_jirawatchesfield_nin');
    }
};

});

parcelRegister("ggSVP", function(module, exports) {

$parcel$export(module.exports, "default", () => $67bb3d8089fa042c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $67bb3d8089fa042c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('single_line_row_height_collapsable_fields');
    }
};

});

parcelRegister("iMyvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd515d7ae24a1bd$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $ccd515d7ae24a1bd$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira-issue-view-child-issues-panel-realtime-update');
    }
};

});

parcelRegister("2pNN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c317a5429c553fb0$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $c317a5429c553fb0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira-issue-view-chin-m2-performance', 'isIssueSearchAPIEnabled', false);
    }
};

});

parcelRegister("5Bxi4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c80591faf091fb2$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5c80591faf091fb2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira_list_check_issue_create_permissions');
    }
};

});

parcelRegister("k3PJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3084fb4096ebf03f$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3084fb4096ebf03f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_list_reparenting');
    }
};

});

parcelRegister("knfEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $91f4d6b980265dc0$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $91f4d6b980265dc0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('frontier-currency-field-formatconfig-query');
    }
};

});

parcelRegister("l8ssf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6503957c800342c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $e6503957c800342c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_inline_editing_flag_fix');
    }
};

});

parcelRegister("dttgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b98ab24c97dab4$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes');
    }
};
var $c7b98ab24c97dab4$export$2e2bcd8739ae039 = $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider;

});

parcelRegister("adKYy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff52f025ed33d5fc$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $ff52f025ed33d5fc$var$JscMergedColumnRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('jira_list_merged_column_gate');
    }
};
var $ff52f025ed33d5fc$export$2e2bcd8739ae039 = $ff52f025ed33d5fc$var$JscMergedColumnRelayProvider;

});

parcelRegister("iLxt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c35fdb8bdb84235d$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $c35fdb8bdb84235d$var$NinMultiGroupPickerCellRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('nin_multi_group_picker_cell');
    }
};
var $c35fdb8bdb84235d$export$2e2bcd8739ae039 = $c35fdb8bdb84235d$var$NinMultiGroupPickerCellRelayProvider;

});


parcelRegister("8mLHi", function(module, exports) {

let $6175607aaa575b63$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $6175607aaa575b63$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $6175607aaa575b63$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $6175607aaa575b63$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $6175607aaa575b63$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $6175607aaa575b63$var$load("cTJTG"),
            $6175607aaa575b63$var$load("l253H"),
            $6175607aaa575b63$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $6175607aaa575b63$var$load("4Qxp7")
        ]);
    }),
    $6175607aaa575b63$var$load("fliVL"),
    $6175607aaa575b63$var$load("ffQaD"),
    $6175607aaa575b63$var$load("kvRbA"),
    $6175607aaa575b63$var$load("g4v9U")
]).then(()=>parcelRequire('aggrw'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});



parcelRegister("aBLlP", function(module, exports) {

$parcel$export(module.exports, "JQLBuilder", () => $1838bdb8fc139aec$export$78a0bbe8e3931cd9);
$parcel$export(module.exports, "onChildIssueLoadErrorFlag", () => $1838bdb8fc139aec$export$24da1c8f64e28465);
$parcel$export(module.exports, "createConfigurableChildIssuesPanelQueryVariables", () => $1838bdb8fc139aec$export$589dd4cb8aa6c352);
$parcel$export(module.exports, "getColumnConfigOverrides", () => $1838bdb8fc139aec$export$ed1c7263cb52d59);

var $6Uevs = parcelRequire("6Uevs");

var $4R6GH = parcelRequire("4R6GH");

var $czfFt = parcelRequire("czfFt");

var $65VLO = parcelRequire("65VLO");

var $1daAU = parcelRequire("1daAU");

var $fKCri = parcelRequire("fKCri");
const $1838bdb8fc139aec$export$78a0bbe8e3931cd9 = ({ issueKey: issueKey, hideDone: hideDone, sortColumn: sortColumn, sortDirection: sortDirection, filterSubtasks: filterSubtasks })=>{
    const hideDoneFlag = hideDone === 'true';
    const excludeDoneIssuesJQL = hideDoneFlag ? '& NOT statusCategory=Done' : '';
    // TODO: Remove on jira-issue-view-child-issues-panel-merge-subtasks cleanup
    const hierarchyLevelJQL = filterSubtasks === null ? '' : `AND hierarchyLevel ${filterSubtasks ? '=' : '!='} -1`;
    return `parent = ${issueKey} ${excludeDoneIssuesJQL} ${hierarchyLevelJQL} ORDER BY ${sortColumn} ${sortDirection}`;
};
const $1838bdb8fc139aec$export$24da1c8f64e28465 = {
    type: 'error',
    title: (0, $fKCri.default).getChildIssueErrorTitle,
    description: (0, $fKCri.default).getChildIssueErrorDescription,
    isAutoDismiss: true,
    messageId: 'issue-view-common-views.child-issues-panel.configurable-child-issues-panel.utils.on-child-issue-load-error-flag.error',
    messageType: 'transactional'
};
const $1838bdb8fc139aec$export$7cdcdac151ac7d0 = ({ cloudId: cloudId, activationId: activationId })=>(0, $6Uevs.JiraIssueSearchViewAri).create({
        siteId: cloudId,
        activationId: activationId,
        namespaceId: 'CHILD_ISSUE_PANEL',
        viewId: 'list_default'
    }).toString();
const $1838bdb8fc139aec$export$589dd4cb8aa6c352 = ({ cloudId: cloudId, jql: jql, fieldSetIds: fieldSetIds, issueKey: issueKey })=>({
        cloudId: cloudId,
        issueSearchInput: {
            jql: jql
        },
        amountOfColumns: (0, $czfFt.MAX_COLUMNS),
        namespace: 'CHILD_ISSUE_PANEL',
        options: {},
        fieldSetIds: fieldSetIds,
        shouldQueryFieldSetsById: false,
        fieldSetsInput: {
            viewInput: {
                namespace: 'CHILD_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        filterId: undefined,
        fieldSetsContext: {
            issueContext: {
                issueKey: issueKey
            }
        },
        first: (0, $4R6GH.fg)('jira-issue-view-child-issues-panel-pagination') ? (0, $1daAU.CHILD_ISSUES_PAGE_SIZE) + 2 : undefined,
        issueKey: issueKey
    });
const $1838bdb8fc139aec$var$bigColumnWidth = {
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: 54,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY]: 80,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: 45,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).NUMBER]: 45,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).PRIORITY]: 112,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ASSIGNEE]: 132,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).STATUS]: 112,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: 32
};
const $1838bdb8fc139aec$var$smallColumnWidth = {
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: 40,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY]: 80,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: 45,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).NUMBER]: 45,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).PRIORITY]: 40,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ASSIGNEE]: 40,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).STATUS]: 112,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: 32
};
const $1838bdb8fc139aec$export$40a21882702c4e3f = ()=>{
    return {
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: ()=>({
                defaultWidth: 40
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY]: ()=>({
                defaultWidth: 80
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY]: ()=>({
                defaultWidth: 342
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: ()=>({
                defaultWidth: 45
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).NUMBER]: ()=>({
                defaultWidth: 45
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).PRIORITY]: ()=>({
                defaultWidth: 40
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ASSIGNEE]: ()=>({
                defaultWidth: 40
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).STATUS]: ()=>({
                defaultWidth: 112
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: ()=>({
                defaultWidth: 32
            })
    };
};
const $1838bdb8fc139aec$export$ed1c7263cb52d59 = (containerWidth, userPreferredLayout)=>{
    if (!containerWidth) return $1838bdb8fc139aec$export$40a21882702c4e3f();
    const miscellaneous = 15; // padding/margin etc
    const calculatedResult = {};
    const defaultSummaryWidth = 342;
    // full page
    if (containerWidth > 760) {
        Object.entries($1838bdb8fc139aec$var$bigColumnWidth).forEach(([type, width])=>{
            calculatedResult[type] = ()=>({
                    defaultWidth: width
                });
        });
        calculatedResult[(0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY] = (allTypes)=>{
            if (allTypes) {
                const isWideLayout = userPreferredLayout === 'WIDE';
                const minimumSummaryWidthInWideLayout = 520;
                const defaultColumnWidth = isWideLayout ? 170 : 0;
                const restWidth = allTypes.reduce((acc, current)=>{
                    return acc + ($1838bdb8fc139aec$var$bigColumnWidth[current] || defaultColumnWidth);
                }, 0);
                const maxCanAllotWidth = Math.floor(containerWidth - restWidth - $1838bdb8fc139aec$var$bigColumnWidth[(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS] - miscellaneous);
                const defaultWidth = isWideLayout ? Math.max(maxCanAllotWidth, minimumSummaryWidthInWideLayout) : maxCanAllotWidth;
                return {
                    defaultWidth: defaultWidth
                };
            }
            return {
                defaultWidth: defaultSummaryWidth
            };
        };
        return calculatedResult;
    }
    const minimumSummaryWidth = 100;
    Object.entries($1838bdb8fc139aec$var$smallColumnWidth).forEach(([type, width])=>{
        calculatedResult[type] = ()=>({
                defaultWidth: width
            });
    });
    calculatedResult[(0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY] = (allTypes)=>{
        if (allTypes) {
            const restWidth = allTypes.reduce((acc, current)=>{
                return acc + ($1838bdb8fc139aec$var$smallColumnWidth[current] || 0);
            }, 0);
            return {
                defaultWidth: Math.max(Math.floor(containerWidth - restWidth - $1838bdb8fc139aec$var$smallColumnWidth[(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS] - miscellaneous), minimumSummaryWidth)
            };
        }
        return {
            defaultWidth: defaultSummaryWidth
        };
    };
    return calculatedResult;
};

});
parcelRegister("6Uevs", function(module, exports) {

$parcel$export(module.exports, "JiraIssueSearchViewAri", () => $507339ba85dce294$export$b7a84334c319d601);

var $4PmOU = parcelRequire("4PmOU");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issue-search-view/manifest.ts
var $507339ba85dce294$var$jiraIssueSearchViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $4PmOU.JiraIssueSearchViewAriResourceOwner),
    resourceType: (0, $4PmOU.JiraIssueSearchViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{namespaceId}/{viewId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        namespaceId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/,
        // eslint-disable-line no-useless-escape
        viewId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-search-view/index.ts
var $507339ba85dce294$export$b7a84334c319d601 = class _JiraIssueSearchViewAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._namespaceId = opts.resourceIdSegmentValues.namespaceId, this._viewId = opts.resourceIdSegmentValues.viewId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get namespaceId() {
        return this._namespaceId;
    }
    get viewId() {
        return this._viewId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $507339ba85dce294$var$jiraIssueSearchViewAriStaticOpts.qualifier,
            platformQualifier: $507339ba85dce294$var$jiraIssueSearchViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $507339ba85dce294$var$jiraIssueSearchViewAriStaticOpts.resourceOwner,
            resourceType: $507339ba85dce294$var$jiraIssueSearchViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.namespaceId}/${opts.viewId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                namespaceId: opts.namespaceId,
                viewId: opts.viewId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $507339ba85dce294$var$jiraIssueSearchViewAriStaticOpts);
        return new _JiraIssueSearchViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $507339ba85dce294$var$jiraIssueSearchViewAriStaticOpts);
        return new _JiraIssueSearchViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            namespaceId: this.namespaceId,
            viewId: this.viewId
        };
    }
};

});
parcelRegister("4PmOU", function(module, exports) {

$parcel$export(module.exports, "JiraIssueSearchViewAriResourceOwner", () => $383da075b23f9b48$export$b384c8149626eef3);
$parcel$export(module.exports, "JiraIssueSearchViewAriResourceType", () => $383da075b23f9b48$export$39acd84ed28a2768);
// src/jira/issue-search-view/types.ts
var $383da075b23f9b48$export$b384c8149626eef3 = "jira", $383da075b23f9b48$export$39acd84ed28a2768 = "issue-search-view";

});


parcelRegister("fKCri", function(module, exports) {

$parcel$export(module.exports, "default", () => $36a44fbc32badf5a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $36a44fbc32badf5a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    resetColumnsErrorTitle: {
        "id": "issue-view-common-views.child-issues-panel.configurable-child-issues-panel.reset-columns-error-title",
        "defaultMessage": "We couldn't restore the default columns"
    },
    getChildIssueErrorTitle: {
        "id": "issue-view-common-views.child-issues-panel.configurable-child-issues-panel.get-child-issue-error-title",
        "defaultMessage": "We couldn't get your child issues"
    },
    getChildIssueErrorDescription: {
        "id": "issue-view-common-views.child-issues-panel.configurable-child-issues-panel.get-child-issue-error-description",
        "defaultMessage": "Refresh and try again."
    },
    getChildIssueErrorTitleIssueTermRefresh: {
        "id": "issue-view-common-views.child-issues-panel.configurable-child-issues-panel.get-child-issue-error-title-issue-term-refresh",
        "defaultMessage": "We couldn't get your child work items"
    }
});

});




$parcel$global.rlb("fdfwb")
//# sourceMappingURL=async.a3c29696.js.map
